import { useEffect, useRef, useState } from "react";
import { ILogin, IPermissionProps } from "../../../models/Login";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Fetch } from "../../../shared/Fetch";
import { Search } from "../../../shared/Search";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { Accordion, AccordionTab } from "primereact/accordion";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { safeFormatDate } from "../../../models/DateFormatMapper";
import { Dialog } from "primereact/dialog";
import EmailTemplateSetting from "./EmailTemplateSetting";

interface Iprops {
    setModal: (modal: any) => void,
    toast: any,
    reload: boolean,
    // permissions: IPermissionProps,
}

interface IPOC_Setting {
    id?: number,
    last_Req_Days?: number,
    last_ECS_Days?: number,
    last_ECI_Days?: number,
    last_PO_Days?: number,
    blacklist_Company_Request_Count?: number,
    updated_By?: string,
    updated_At?: Date,
}

interface IMax_Email_Setting {
    id?: number,
    company_Name?: string,
    limit_Days?: number,
    max_POC_Reach_P_Job?: number,
    max_Sales_P_Lead?: number,
    max_POC_Reach?: number,
    updated_By?: string,
    updated_At?: Date,
}

export const Table = (props: Iprops) => {
    const [loading, setLoading] = useState(false);
    const [activeIndex, setActiveIndex] = useState<number | number[]>();
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IPOC_Setting>, loading: boolean });
    const [tableData2, setTableData2] = useState({ tableData: [], loading: false } as { tableData: Array<IMax_Email_Setting>, loading: boolean });

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const DateFormat = loginObj.date_Format;

    const dt1 = useRef<any>(null);
    const dt2 = useRef<any>(null);

    const handleCollapseAll = () => {
        setActiveIndex([]);
    };

    const handleExpandAll = () => {
        setActiveIndex([0, 1, 2]);
    };

    const openEdit = () => {
        props.setModal({ open: true });
    };

    const leftToolbarTemplate = () => {
        return <>
            <Button label="Expand All" className="p-button-success mr-2 bg-primary" onClick={handleExpandAll} />
            <Button label="Collapse All" className="p-button-success mr-2 bg-primary" onClick={handleCollapseAll} />
        </>
    }

    const rightToolbarTemplate = () => {
        return <Button label="Update" icon="pi pi-pencil" className="p-button-success mr-2 bg-primary" onClick={openEdit} />
    }

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("lead-capture/leadCpaturedPOCEmailSetting", "GET", null, null, props.toast);
        if (response) {
            const data: any = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }

    const loadTableData2 = async () => {
        setTableData2({ tableData: tableData2.tableData, loading: true });
        const response = await Fetch("lead-capture/leadCpaturedCompanyEmailSetting", "GET", null, null, props.toast);
        if (response) {
            const data: any = await response.json();
            setTableData2({ tableData: data, loading: false });
        } else setTableData2({ tableData: tableData2.tableData, loading: false });
    }

    useEffect(() => {
        loadTableData();
        loadTableData2();
    }, [props.reload]);

    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
            <Accordion multiple activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} >
                <AccordionTab header="InActive POC Setting">
                    <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                        size="small"
                        ref={dt1}
                        value={tableData.tableData}
                        emptyMessage="No Data found."
                        loading={tableData.loading}>
                        <Column field="blacklist_Company_Request_Count" header="Blacklist Company On Request Count" />
                        <Column field="last_Req_Days" header="Last Req Days" />
                        <Column field="last_ECS_Days" header="Last ECS Days" />
                        <Column field="last_ECI_Days" header="Last ECI Days" />
                        <Column field="last_PO_Days" header="Last PO Days" />
                        <Column field="updated_By" header="Updated By" />
                        <Column field="updated_At" header="Updated At" body={(rowData: IPOC_Setting) => safeFormatDate(new Date(rowData?.updated_At || "").toDateString(), "dd/MM/yyyy", DateFormat)} />
                    </DataTable>
                </AccordionTab>
                <AccordionTab header="Max Email Sending Setting">
                    <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                        size="small"
                        ref={dt2}
                        value={tableData2.tableData}
                        emptyMessage="No Data found."
                        loading={tableData2.loading}>
                        <Column field="company_Name" header="Company Name" />
                        {/* <Column field="limit_Days" header="Days Limit" /> */}
                        <Column field="max_POC_Reach_P_Job" header="Max POC Reach Per Job" />
                        <Column field="max_Sales_P_Lead" header="Max Sales Per Job" />
                        <Column field="max_POC_Reach" header="Max Reach To A POC Per Company" />
                        <Column field="updated_By" header="Updated By" />
                        <Column field="updated_At" header="Updated At" body={(rowData: IMax_Email_Setting) => safeFormatDate(new Date(rowData?.updated_At || "").toDateString(), "dd/MM/yyyy", DateFormat)} />
                    </DataTable>
                </AccordionTab>
                <AccordionTab header="Email Template Setting">
                    <EmailTemplateSetting toast={props.toast} />
                </AccordionTab>
            </Accordion>
            <ConfirmDialog />
        </>
    );
}